import { Message } from '@/services/types/artifact-types';

import { ConversationParticipantsBlock } from './ConversationParticipantsBlock';
import { SenderInitialsAvatar } from './SenderInitialsAvatar';
import { getSender } from './utils';

interface MessageHeaderProps {
  message: Message;
  formatRelativeTime: (dateString: string) => string;
  showRecipients?: boolean;
}

export const MessageHeader = ({
  message,
  formatRelativeTime,
  showRecipients = true,
}: MessageHeaderProps) => {
  const sender = getSender(message);
  const senderForAvatar = sender
    ? { name: sender.name ?? undefined, handle: sender.handle ?? undefined }
    : null;
  return (
    <div className="flex items-top w-full gap-0 px-0 py-4 border-b border-gray-200">
      {/* Avatar */}
      <div className="flex-shrink-0">
        <SenderInitialsAvatar sender={senderForAvatar} />
      </div>
      {/* Fixed spacer */}
      <div className="w-3" />
      {/* Expanding participants block */}
      <div className="flex-1 min-w-0">
        <div className="truncate">
          <ConversationParticipantsBlock
            message={message}
            showRecipients={showRecipients}
          />
        </div>
      </div>
      {/* Timestamp */}
      <div className="flex-shrink-0 ml-2 max-w-[30vw]">
        <span className="text-xs text-gray-500 whitespace-nowrap">
          {formatRelativeTime(message.created_at)}
        </span>
      </div>
    </div>
  );
};
